import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OutcomesComponent } from './outcomes.component';
import { SharedModule } from '@app/shared/shared.module';
@NgModule({
  imports: [CommonModule, FormsModule, SharedModule],
  exports: [OutcomesComponent],
  declarations: [OutcomesComponent],
})
export class OutcomesModule {}
